// `Array.prototype.at` (ES2022) only exists from Chrome 92 / Safari 15.4. The
// build targets es2020, which downlevels syntax but polyfills no built-in, so
// the call reaches older engines as-is: the home crashed to the error screen on
// `.at(0)` in `CatalogLayoutModule` (SHORTS-WEB-BJ) and `web-vitals` rejects on
// `.at(-1)` (SHORTS-WEB-37).
//
// Installed here rather than rewritten at the call sites, so dependencies are
// covered too — that `web-vitals` is the one Amplitude's autocapture pulls in
// (`@amplitude/plugin-web-vitals-browser`), not an import of ours. Imported
// first in src/main.tsx.
//
// No-op on engines that already implement it.

function at<T>(this: ArrayLike<T>, index: number): T | undefined {
  const relative = Math.trunc(index) || 0;
  const position = relative < 0 ? this.length + relative : relative;
  return position < 0 || position >= this.length ? undefined : this[position];
}

if (!("at" in Array.prototype)) {
  Object.defineProperty(Array.prototype, "at", {
    value: at,
    writable: true,
    enumerable: false,
    configurable: true,
  });
}

// A file with no import or export is a script to TypeScript, which the unit
// test can't `import()`.
export {};
